<template>
    <el-dialog v-model="deleteDialogVisible" :title="title" width="585px" center>
            <p class="delete-dialog-text"> {{content1}} </p>
            <p class="delete-dialog-text"> {{content2}} </p>
            <template #footer>
            <span class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmDelete">
                确认删除
                </el-button>
            </span>
            </template>
        </el-dialog>
</template>
<script setup>
import { ref } from 'vue';

let deleteDialogVisible = ref(false);
const emits = defineEmits(['confirmDelete'])
const props = defineProps({
    title:{
        type: String,
        default: '数据删除'
    },
    content1: {
        type: String,
        default: '删除后该答卷数据将无法找回！'
    },
    content2: {
        type: String,
        default: '被删除的答卷数据，无法计入答题数据看板'
    },
})
defineExpose({deleteDialogVisible});
const confirmDelete = async() => {
    await emits('confirmDelete');
    deleteDialogVisible.value = false;

}
</script>
<style lang="scss" scoped>
.delete-dialog-text {
        text-align: center;
        font-size: 14px;
        &:nth-child(1) {
            color: rgba(112, 120, 134, 1);
            margin-bottom: 10px;
        }
        &:nth-child(2) {
            color:  rgba(183, 186, 191, 1);
        }
    }
</style>